'use client';

import { useEffect, useMemo, useRef } from 'react';

import { useConsent } from 'utils/consent/ConsentProvider';
import { ConsentScript } from 'utils/scripts/ConsentScript';

export const HubSpotScript = () => {
  const { hasMarketingConsent, isLoaded } = useConsent(); // read marketing consent + CMP readiness
  const initialized = useRef(false); // track first consent sync

  useMemo(() => {
    
    if (typeof window !== 'undefined') {
      window._hsq = window._hsq || [];
    } // ensure HubSpot queue exists early

    return null;
  }, []);

  useEffect(() => {
    if (!isLoaded) {
      return;
    } // wait until OneTrust is loaded

    const _hsq = (window._hsq = window._hsq || []);

    if (!initialized.current) {
      // set initial tracking state once
      if (hasMarketingConsent) {
        _hsq.push(['doNotTrack', { track: true }]);
      } else {
        _hsq.push(['doNotTrack']);
      }

      initialized.current = true;

      return;
    }

    // update tracking when consent changes
    if (hasMarketingConsent) {
      _hsq.push(['doNotTrack', { track: true }]);
    } else {
      _hsq.push(['doNotTrack']);
    }
  }, [hasMarketingConsent, isLoaded]);

  return (
    <ConsentScript
      category="C0004" // marketing consent category
      src="https://js.hs-scripts.com/50768109.js" // HubSpot loader
      id="hs-script-loader" // prevent duplicate injection
    />
  );
};

declare global {
  interface Window {
    _hsq?: any[]; // HubSpot command queue
  }
}
